import {connect} from 'react-redux';

import IngestReportContainer from './IngestReportContainer';
import {
    setIngestReportAction,
    resetIngestReportAction,
} from './Redux/IngestReportActions';

export const mapState = (state: any) => {
    return {
        ingestReport: state.ingest.ingestReport,
    };
};

export const mapDispatch = {
    setReport: setIngestReportAction,
    resetReport: resetIngestReportAction,
};

export default connect(mapState, mapDispatch)(IngestReportContainer);
